import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { Icon } from 'apps/shared/scripts/components';

import {
  benefitIconClassName,
  benefitIconWrapperClassName,
  benefitItemClassName,
  benefitLabelClassName,
} from './styles';

interface Props {
  label: string;
}

const BenefitItem = ({ label }: Props) => {
  return (
    <div className={benefitItemClassName}>
      <div className={benefitIconWrapperClassName}>
        <Icon className={benefitIconClassName} fa={faCheck} />
      </div>
      <span className={benefitLabelClassName}>{label}</span>
    </div>
  );
};

BenefitItem.displayName = 'BenefitItem';

export default BenefitItem;
